import restrictionService from '@/api/restriction'
import { RESTRICTIONS } from '../types'

import utils from '@/utils/utils'

export default {
  namespaced: true,
  state: {
    restrictions: [],
    availableSites: [],
    availableDeskGroups: [],
    availableDesks: [],
    availableParkings: []
  },
  mutations: {
    [RESTRICTIONS.SET_RESTRICTION](state, restrictions) {
      state.restrictions = restrictions
    },
    [RESTRICTIONS.SET_AVAILABLE_SITES](state, availableSites) {
      state.availableSites = availableSites
    },
    [RESTRICTIONS.SET_AVAILABLE_GROUP_DESKGROUPS](state, availableDeskGroups) {
      state.availableDeskGroups = availableDeskGroups
    },
    [RESTRICTIONS.SET_AVAILABLE_DESKS](state, availableDesks) {
      state.availableDesks = availableDesks
    },
    [RESTRICTIONS.SET_AVAILABLE_PARKINGS](state, availableParkings) {
      state.availableParkings = availableParkings
    }
  },
  actions: {
    setAvailableDeskGroups({commit}, desksBySite){
      const availableDeskGroups = [].concat(...desksBySite.map(desk => desk.deskGroups))
      const setDuplicatedvalues = new Set()
      const filteredAvailableDeskGroups = availableDeskGroups.filter(deskGroup => {
        const duplicate = setDuplicatedvalues.has(deskGroup.id);
        setDuplicatedvalues.add(deskGroup.id);
        return !duplicate;
      })
      commit(RESTRICTIONS.SET_AVAILABLE_GROUP_DESKGROUPS, filteredAvailableDeskGroups)
    },
    setAvailableDesks ({commit}, availableDesks) {
      let listDesk = []
      availableDesks.forEach(deskDetails => {
        let objDesk = undefined
        const groupIds = deskDetails.deskGroups.map(d => d.id)
        objDesk = {
          name:`${deskDetails.desk.name} (${deskDetails.locationName})`,
          groupIds,
          id: deskDetails.desk.id
        }
        listDesk.push(objDesk)
      })
      commit(RESTRICTIONS.SET_AVAILABLE_DESKS, listDesk)
    },
    setAvailableSites ({commit}, availableSites) {
      let listSite = []
      availableSites.forEach(site => {
        let objSite = {
          value: site.id,
          label: site.name,
          locations: site.locations
        }
        listSite.push(objSite)
      })
      commit(RESTRICTIONS.SET_AVAILABLE_SITES, listSite)
    },
    setAvailableParkings ({commit}, availableParkings) {
      commit(RESTRICTIONS.SET_AVAILABLE_PARKINGS, availableParkings)
    },
    getRestrictionsList: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        restrictionService.getRestrictions().then((response) => {
          commit(RESTRICTIONS.SET_RESTRICTION, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getRestriction: function ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        restrictionService.getRestriction(id).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    saveRestriction: function ({dispatch}, configRestriction) {
      dispatch('Global/showLoading', null, {root: true})
      let parkings = configRestriction.parkings.map(p => p.id)
      let desks = configRestriction.desks.map(d => d.id)
      let restriction = {
        id: configRestriction.id,
        name: configRestriction.name,
        siteId: configRestriction.siteId,
        start: utils.formatDateTimeToUtc(configRestriction.startDate),
        finish: configRestriction.finishDate ? utils.formatDateTimeToUtc(configRestriction.finishDate) : null,
        recurrenceType: configRestriction.recurrenceType,
        isForever: configRestriction.isForever,
        parkings: parkings,
        desks: desks,
        active: configRestriction.active
      }
      return new Promise((resolve, reject) => {
        restrictionService.saveRestriction(restriction).then(() => {
          dispatch('getRestrictionsList')
          dispatch('Global/showMessage', configRestriction.id ? 'editRestrictionSuccessfully' : 'addRestrictionSuccessfully', {root: true})
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    activateRestriction: function (_, restrictionId) {
      return new Promise((resolve, reject) => {
        restrictionService.activateRestriction(restrictionId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateRestriction: function (_, restrictionId) {
      return new Promise((resolve, reject) => {
        restrictionService.deactivateRestriction(restrictionId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    editRestriction: function ({dispatch}, restriction) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        restrictionService.editRestriction(restriction).then(() => {
          dispatch('getRestrictionsList')
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    deleteRestriction: function ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        restrictionService.deleteRestriction(id).then(() => {
          dispatch('getRestrictionsList').then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          }).finally(() => {
            dispatch('Global/hideLoading', null, {root: true})
          })
        })
      })
    }
  }
}
